import React, { Component, useState } from "react";
import { useLocation } from 'react-router-dom';
import axios from "axios"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

class SuggestionsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: '',
            submittedstate: 'not-submitted'
        };
        this.messages = {
            success: {
                header: `Submission successful`,
                body: `Thanks for your suggestion!`
            },
            fail: {
                header: 'Sorry, there is something wrong on our end',
                body: 'Please try again later.'
            }
        };
    }

    handleSubmit(e) {
        e.preventDefault();
        axios({
            method: "POST",
            url: "api/Home/SubmitSuggestion",
            data: JSON.stringify({
                Description: this.state.description
            }),
            headers: {
                'content-type': 'application/json'
            }
        }).then((response) => {
            if (response.status == 200) {
                this.setState({ submittedstate: 'submitted-success' })
                //this.resetForm();
            } else {
                this.setState({ submittedstate: 'submitted-error' })
            }
        }).catch((error) => {
            console.error(error);
            this.setState({ submittedstate: 'submitted-error' })
        });
    }


    onDescriptionChange(event) {
        this.setState({ description: event.target.value });
    }

    formPageContent() {
        return (
            <div className="col-sm-8 col-sm-offset-4">
                <h1>Suggestions</h1>
                <p>Please leave a detailed response in the following field for suggestions to Leadership, Culture, Facilities and anything else regarding NRG. Responses will be anonymous.</p>
                <form id="suggestion-form" className="form-horizontal" onSubmit={this.handleSubmit.bind(this)}>
                    <div className="form-group">
                        <label htmlFor="input-description" className="col-sm-12 control-label" style={{textAlign:'left'}}>
                            Write your suggestions for NRG below:
                        </label>
                        <textarea style={{minHeight: '150px'}} className="form-control" id="input-description" placeholder="" value={this.state.description} onChange={this.onDescriptionChange.bind(this)} required />
                    </div>
                    <div className="form-group">
                        <div style={{textAlign: 'right', paddingLeft: 0}}>
                            <button type="submit" className="btn btn-default" {...!this.state.description.trim() && {disabled: true}}>Submit</button>
                        </div>
                    </div>
                </form>
            </div>
            );
    }

    render() {
        let contents = this.formPageContent();
        if (this.state.submittedstate !== 'not-submitted') {
            let innerContent = this.state.submittedstate === 'submitted-success' ? this.messages.success : this.messages.fail;
            contents = <div className="col-sm-8 col-sm-offset-4">
                <h3>{innerContent.header}</h3>
                <p>{innerContent.body}</p>
            </div>;
        }
        return (
            <div className={[this.page, "container-fluid"].join(" ")}>
                <div className="row">
                    {contents}
                </div>
            </div>
        );
    }
}

export default SuggestionsForm;